import { Draggable } from 'react-beautiful-dnd';
import { connect } from 'react-redux';
import { IDataStorage, ServerFileUrl } from '../../core';
import { FxTranslate } from '../../core/translate';
import { GetConfigEstado } from '../../services/operaciones';
import { Tooltip } from '../prime';
import { ICardInfo } from './';
import styles from './card.module.scss';

const format = (window as any).format;

export type IProps = {
  storage: IDataStorage;
  t: FxTranslate;

  index: number;
  data?: ICardInfo;

  /** Ocurre cuando se hace click sobre la tarjeta para abrirla */
  onOpen: (data?: ICardInfo) => void;
}

function BoardComponent({ storage, t, index, data, onOpen } : IProps) {
  const vendedor_id = !!data?.op_id ? data.op_vendedor_id : data?.vendedor_id;
  const vendedor_nombre = !!data?.op_id ? data.op_vendedor_nombre : data?.vendedor_nombre;
  const vendedor_avatar = !!data?.op_id ? data.op_vendedor_avatar : data?.vendedor_avatar;

  const estadoConfig = GetConfigEstado(data?.estado);

  return !data ? <></> :
    <Draggable draggableId={data.id} index={index}>
      {(provided, snapshot) => (
        <div 
          className={`${styles["container-card"]} ${snapshot.isDragging && styles["container-card-dragging"]}`} 
          ref={provided.innerRef} 
          onDoubleClick={() => onOpen(data)}
          //onClick={() => console.log("CLICK CARD", data.id)}
          {...provided.draggableProps} 
          {...provided.dragHandleProps}
        >
          <div className={styles["card-header"]} style={{ borderBottom: `1px solid ${estadoConfig?.bordercolor}` }}>
            <div className={`${styles["card-header-nro"]} p-text-nowrap p-text-truncate`}>#{data.tipo === 'CO' ? data.coti_codigo : data.op_codigo}</div>
            <div className={styles["card-header-estado"]} style={{ backgroundColor: estadoConfig?.backcolor, color: estadoConfig?.forecolor }}>{t(`@Id.Operacion.Estado#${data.estado}`)}</div>
          </div>
          <div className={styles["card-info"]}>
              <span className={styles["card-info-email"]}>{data.email}</span>
            <p style={{ margin: 0, wordWrap: 'break-word' }}>
              {!!data.proximaGestionFecha &&
                <span className={styles["badge"]} style={{ backgroundColor: '#B3591B', color: '#fff', alignItems: 'center' }}>
                  <i className="pi pi-calendar" style={{ marginRight: 5 }}></i>{format(data.proximaGestionFecha, 'dd MMM')}
                </span>
              }
              {!!data.mailme && <span className={styles["badge"]} style={{ backgroundColor: 'var(--primary)', color: '#fff', alignItems: 'center' }}>{t("Card.Tag.mailme")}</span>}
              {(!!data.callme || !!data.op_callme) && <span className={styles["badge"]} style={{ backgroundColor: 'var(--success)', color: '#fff', alignItems: 'center' }}>{t("Card.Tag.op_callme")}</span>}
            </p>
          </div>
          <div className={styles["card-footer"]}>
            {!!vendedor_id ? <>
              <Tooltip target={`#img-${data.id}-vendedor`} mouseTrack mouseTrackLeft={10} />
              <img 
                id={`img-${data.id}-vendedor`} data-pr-tooltip={vendedor_nombre} data-pr-position="left" 
                width={24} height={24} 
                src={!!vendedor_avatar ? ServerFileUrl(vendedor_avatar as number) : "/images/avatar.png"} 
                alt={vendedor_nombre} 
              />
            </> : <div></div>}
            <Tooltip target={`#img-${data.id}-cliente`} mouseTrack mouseTrackLeft={10}  />
            <img 
              id={`img-${data.id}-cliente`} data-pr-tooltip={data?.cliente_nombre} data-pr-position="right" 
              width={24} height={24} style={{ marginRight: 'auto' }}
              src={!!data?.cliente_logo ? ServerFileUrl(data.cliente_logo) : "/images/cliente.png"} 
              alt={data?.cliente_nombre} 
            />
          </div>
        </div>
      )}
    </Draggable>;
}

export default connect((s:any) => ({ storage:s.main }))(BoardComponent);